import { render, staticRenderFns } from "./UpdatePMG.vue?vue&type=template&id=2d139156&"
import script from "./UpdatePMG.vue?vue&type=script&lang=js&"
export * from "./UpdatePMG.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePMG.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports